// extracted by mini-css-extract-plugin
export default {"box":"Column_box__ACMN0","info":"Column_info__IEyBQ","legend":"Column_legend__jDXaf","legend_app":"Column_legend_app__JNmuQ","legend_tun":"Column_legend_tun__3K+7J"};